import { AxiosConfigBenchmarking } from "Benchmarking/Config/AxiosConfig";

export const getInstitutionExplore = (callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/institutions/explore/`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionRank = (data, callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/institution/rank`;

  var data_copy = {};
  Object.assign(data_copy, data);
  data_copy["classification_strings"] = data_copy["classifications"];
  axios
    .post(url, data_copy)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionSuggestSearch = (param, callback) => {
  const axios = AxiosConfigBenchmarking();
  const url = `/institutions/suggest/${param}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSearchInstitution = (filters, callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/institution/search/`;
  // if (filters.query) {
  //   if (url[url.length - 1] == "?") {
  //     url += `query=${filters.query}`;
  //   } else {
  //     url += `&query=${filters.query}`;
  //   }
  // }
  // if (filters.hbcu == 0 || filters.hbcu == 1) {
  //   if (url[url.length - 1] == "?") {
  //     url += `hbcu=${filters.hbcu}`;
  //   } else {
  //     url += `&hbcu=${filters.hbcu}`;
  //   }
  // }
  // if (filters.hsi == 0 || filters.hsi == 1) {
  //   if (url[url.length - 1] == "?") {
  //     url += `hsi=${filters.hsi}`;
  //   } else {
  //     url += `&hsi=${filters.hsi}`;
  //   }
  // }
  // if (filters.msi == 0 || filters.msi == 1) {
  //   if (url[url.length - 1] == "?") {
  //     url += `msi=${filters.msi}`;
  //   } else {
  //     url += `&msi=${filters.msi}`;
  //   }
  // }
  // if (filters.womens == 0 || filters.womens == 1) {
  //   if (url[url.length - 1] == "?") {
  //     url += `womens=${filters.womens}`;
  //   } else {
  //     url += `&womens=${filters.womens}`;
  //   }
  // }
  // if (filters.basic2021) {
  //   if (url[url.length - 1] == "?") {
  //     url += `basic2021=${filters.basic2021}`;
  //   } else {
  //     url += `&basic2021=${filters.basic2021}`;
  //   }
  // }
  // if (filters.stabbr) {
  //   if (url[url.length - 1] == "?") {
  //     url += `stabbr=${filters.stabbr}`;
  //   } else {
  //     url += `&stabbr=${filters.stabbr}`;
  //   }
  // }

  axios
    .post(url, filters)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionCompare = (data, callback) => {
  const axios = AxiosConfigBenchmarking();
  let url = `/institution/compare`;

  axios
    .post(url, { candidates: data })
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionDepartmentById = (id, callback) => {
  const axios = AxiosConfigBenchmarking();
  const url = `/institution/get_departments/?institutionId=${id}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionSummaryById = (id, callback) => {
  const axios = AxiosConfigBenchmarking();
  const url = `/institution/summary/?institutionId=${id}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getInstitutionBasicStatById = (id, callback) => {
  const axios = AxiosConfigBenchmarking();
  const url = `/institution/base_stats/?institutionId=${id}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionAdvancedStatById = (id, callback) => {
  const axios = AxiosConfigBenchmarking();
  const url = `/institution/advanced_stats/?institutionId=${id}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionConceptMap = (
  id,
  startYear,
  endYear,
  granularityLevel,
  params,
  department,
  callback
) => {
  const axios = AxiosConfigBenchmarking();
  let url;
  if (params) {
    url = `/institution/concepts_map/?institutionId=${id}&fromYear=${startYear}&toYear=${endYear}&granularityLevel=${granularityLevel}&${params}`;
  } else {
    url = `/institution/concepts_map/?institutionId=${id}&fromYear=${startYear}&toYear=${endYear}&granularityLevel=${granularityLevel}`;
  }

  if (department) {
    url = url + `&department=${department}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionAuthorsByID = (
  id,
  page,
  rowsPerPage,
  startYear,
  endYear,
  keywords,
  department,
  callback
) => {
  const axios = AxiosConfigBenchmarking();
  let url;
  if (keywords.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url = `/institution/authors/?institutionId=${id}&page=${
      page - 1
    }&rowsPerPage=${rowsPerPage}&fromYear=${startYear}&toYear=${endYear}&${params.toString()}`;
  } else {
    url = `/institution/authors/?institutionId=${id}&page=${
      page - 1
    }&rowsPerPage=${rowsPerPage}&fromYear=${startYear}&toYear=${endYear}`;
  }
  if (department) {
    url = url + `&department=${department}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitutionPublicationsByID = (
  id,
  page,
  rowsPerPage,
  startYear,
  endYear,
  keywords,
  department,
  callback
) => {
  const axios = AxiosConfigBenchmarking();
  let url;
  if (keywords.length > 0) {
    let params = new URLSearchParams();
    console.log(keywords);
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("keyword", keyword.value);
      }
    });
    url = `/institution/publications/?institutionId=${id}&page=${
      page - 1
    }&rowsPerPage=${rowsPerPage}&fromYear=${startYear}&toYear=${endYear}&${params.toString()}`;
  } else {
    url = `/institution/publications/?institutionId=${id}&page=${
      page - 1
    }&rowsPerPage=${rowsPerPage}&fromYear=${startYear}&toYear=${endYear}`;
  }
  if (department) {
    url = url + `&department=${department}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
